<template>
  <ListPayout v-if="canSeePayouts" />
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ListPayout from "@/components/payouts/PayoutsList.vue";

export default {
  components: {
    ListPayout,
  },

  computed: {
    ...mapGetters("profile", ["canSeePayouts"])
  },
  methods: {
    ...mapActions("payouts", ["getAllPayouts"])
  },
  async mounted() {
    if (this.canSeePayouts) {
      this.getAllPayouts();
    }
  },
};
</script>

